import { h } from 'preact';
import { getCountries } from '../../lib/Country';
import { getAssetPath } from '../../lib/Utils';
import './index.less';

export default ({
  style = {},
  selectedCountry,
  onCountryChange,
  containerClassName = '',
  flagContainerClass = '',
  flagClass = '',
  displayCodeClass = '',
  countryDropDownClass = ''
}) => (
  <div style={style} className={`country-drop-down-container ${containerClassName}`}>
    <div className={`code-flag-container ${flagContainerClass}`}>
      <img
        className={`country-flag ${flagClass}`}
        src={getAssetPath(
          `flags/${selectedCountry.countryCode && selectedCountry.countryCode.toLowerCase()}.png`
        )}
        alt={`${selectedCountry.countryCode.toLowerCase()} flag`}
        height={13}
        width={20}
      />
      <span className={`country-code ${displayCodeClass}`}>{selectedCountry.callingCode}</span>
    </div>
    <select
      value={JSON.stringify(selectedCountry)}
      onChange={onCountryChange}
      className={`country-select ${countryDropDownClass}`}
    >
      {getCountries().map((country) => (
        <option
          value={JSON.stringify(country)}
          label={country.name + ' (' + country.callingCode + ')'}
        >
          {country.name + ' (' + country.callingCode + ')'}
        </option>
      ))}
    </select>
  </div>
);
